import { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../utils/firebase';

/**
 * Custom hook to fetch 28-day review trends from systemStats.
 * Returns hospitality and beer review counts in chronological order for sparklines.
 */
function useReviewsTrend() {
  const [trendData, setTrendData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTrendData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch last 28 daily entries ordered by date desc, then reverse to chronological
        const statsRef = collection(db, 'systemStats');
        const statsQuery = query(statsRef, orderBy('date', 'desc'), limit(28));
        const querySnapshot = await getDocs(statsQuery);

        if (!querySnapshot.empty) {
          const data = querySnapshot.docs.map((doc) => {
            const docData = doc.data();
            return {
              date: docData.date?.toDate?.() || new Date(docData.date),
              hospitalityReviewsCount:
                docData.metrics?.totalHospitalityReviewsCount || 0,
              beerReviewsCount: docData.metrics?.totalBeerReviewsCount || 0,
            };
          });
          setTrendData(data.reverse());
        } else {
          setTrendData([]);
        }
      } catch (err) {
        console.error('Error fetching review trend data:', err);
        setError(err.message);
        setTrendData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTrendData();
  }, []);

  return { trendData, loading, error };
}

export default useReviewsTrend;
